import {Injectable} from "@angular/core";

import * as jsrsasign from 'jsrsasign';
import {StorageKeysEnum} from "../../storage/storage-keys.enum";

const rs: any = jsrsasign;
const JWS = rs.jws.JWS;
const KEY_PASSWORD = "B4nc4D1d1t4l!";

@Injectable({providedIn: "root"})
export class JwtService {

  generateKeys() {
    const rsaKeypair = rs.KEYUTIL.generateKeypair("RSA", 2048);
    if (sessionStorage.getItem(StorageKeysEnum.PUBLIC_KEY) == null) {
      const publicKey = rs.KEYUTIL.getPEM(rsaKeypair.pubKeyObj);
      let result = publicKey.replace("-----BEGIN PUBLIC KEY-----", "");
      result = result.replace("-----END PUBLIC KEY-----", "");
      result = result.replace(/[\r\n]+/g,"");
      result  = result.trimEnd();
      result  = result.trimStart();
      sessionStorage.setItem(StorageKeysEnum.PUBLIC_KEY, result);
    }
    if (sessionStorage.getItem(StorageKeysEnum.PRIVATE_KEY) == null) {
      const pemPrivate = rs.KEYUTIL.getPEM(rsaKeypair.prvKeyObj, "PKCS8PRV", KEY_PASSWORD);
      let result = pemPrivate.replace("-----BEGIN PUBLIC KEY-----", "");
      result = result.replace("-----END PUBLIC KEY-----", "");
      result = result.replace(/[\r\n]+/g,"");
      result  = result.trimEnd();
      result  = result.trimStart();
      sessionStorage.setItem(StorageKeysEnum.PRIVATE_KEY, pemPrivate);
    }
  }

  signRequest(propertyName: string, payload: any, otpToken: string) {
    const oHeader = {"alg": "RS512", "typ": 'JWT'};
    const oPayload: any = {};
    oPayload.exp = this.getTimeJwt();
    oPayload[propertyName] = payload;
    oPayload["otp"] = otpToken;
    const sHeader = JSON.stringify(oHeader);
    const sPayload = JSON.stringify(oPayload);
    const sPemPrvKey = this.decryptKey();
    const prvKey = rs.KEYUTIL.getKey(sPemPrvKey, KEY_PASSWORD);
    return JWS.sign("RS512", sHeader, sPayload, prvKey);
  }

  decryptKey() {
    const privateKeyEnc = sessionStorage.getItem(StorageKeysEnum.PRIVATE_KEY);
    const privatePwdDec = rs.KEYUTIL.getKeyFromEncryptedPKCS8PEM(privateKeyEnc, KEY_PASSWORD);
    return rs.KEYUTIL.getPEM(privatePwdDec, "PKCS8PRV");
  }

  private getTimeJwt() {
    const d = new Date();
    return d.getTime() + 700000;
  }
}
